// BBS DDD 2020-06-02 TODO: replace lodash usage here. With vanilla js or other lib?
import uniqBy from 'lodash/uniqBy'
import find from 'lodash/find'

import { AcceptJsPaymentComponent, PurchaseOrderComponent } from '../Features/PaymentMethod'

// https://lodash.com/docs/4.17.10#uniqBy
const isAllUniqueValues = (list, iteratee = x => x) => {
    const len = list.length;
    const uniqLength = uniqBy(list, iteratee).length;
    return len === uniqLength;
}


//const addressesAreInvalid = (addresses) => {
//  if (!isAllUniqueValues(addresses.map(address => address.Id))) {
//    console.error('not all Ids unique for ShippingAddresses and BillingAddresses');
//    return true;
//  }
//}

const paymentOptionsAreInvalid = (paymentOptions) => {
    if (!isAllUniqueValues(paymentOptions, po => po.Id)) {
        console.error('not all Ids unique for PaymentOptions');
        return true;
    }
}

const cartItemsAreInvalid = (cartItems) => {
    if (!isAllUniqueValues(cartItems, ci => ci.Id)) {
        console.error('not all Ids unique for CartItems');
        return true;
    }
}

// Perhaps https://validatejs.org/ would be useful here
const initialDataIsInvalid = (initialData) => {
    if (paymentOptionsAreInvalid(initialData.PaymentOptions)) {
        return true;
    }
    if (cartItemsAreInvalid(initialData.CartItems)) {
        return true;
    }
}

const mapTopLevelPropsToInitialStoreState = props => {
    // validate
    if (initialDataIsInvalid(props.initialData)) {
        return {};
    }

    const authorizeDotNetClientSettings = props.initialData.AuthorizeDotNetClientSettings;

    // Add controls to payment if they have one
    const paymentOptions = props.initialData.PaymentOptions.map(po => {
        if (po.Id === authorizeDotNetClientSettings.AuthorizePaymentOptionId) {
           po.paymentOptionComponent = AcceptJsPaymentComponent;
        }
        else if (po.Id === props.purchaseOrderPaymentId) {
            po.paymentOptionComponent = PurchaseOrderComponent;
        }
        return po;
    });

    let selectedPaymentOption = find(paymentOptions, po => po.IsSelected);
    if (!selectedPaymentOption) {
        selectedPaymentOption = paymentOptions[0];
    }

    const allowBillingEqualsShipping = props.initialData.AllowBillingEqualsShipping;
    const selectedShippingAddressId = props.initialData.ShippingAddresses[0] && props.initialData.ShippingAddresses[0].Id;
    const selectedBillingAddressId = (allowBillingEqualsShipping && selectedShippingAddressId)
        ? (selectedShippingAddressId)
        : (props.initialData.BillingAddresses[0] && props.initialData.BillingAddresses[0].Id);
    
    return {
        // BBS DDD 2017-11-19 The state of the ui. Make all ui updates here.
        ui: {
            PhoneNumber: props.initialData.PhoneNumber,
            PhoneText: props.initialData.PhoneText,
            useShippingForBilling: allowBillingEqualsShipping,
            messages: [],
            completeCheckoutButtonText: "Place Order",
            isPlaceOrderPending: false,
            acceptedTermsAndConditions: false,
            cartAnnouncement: props.initialData.CartAnnouncement
        },
        // BBS DDD 2017-11-19 The state of the checkout. Make all business
        // updates here
        entities: {
            Addresses: props.initialData.BillingAddresses.concat(props.initialData.ShippingAddresses),
            BillingAddresses: props.initialData.BillingAddresses.map(addr => addr.Id),
            SelectedBillingAddressId: selectedBillingAddressId,
            ShippingAddresses: props.initialData.ShippingAddresses.map(addr => addr.Id),
            SelectedShippingAddressId: selectedShippingAddressId,
            CartItems: props.initialData.CartItems,
            PaymentOptions: paymentOptions,
            SelectedPaymentOptionId: selectedPaymentOption ? selectedPaymentOption.Id : '',
            ShippingOptions: [],
            isRefreshingShippingOptions: true,
            SelectedShippingOptionId: '',
            Summary: {
                Total: 0,
                SubTotal: 0,
                ShippingTotal: null,
                Currency: 'USD',
                TotalRemaining: 0
            },
            isRefreshingSummary: true,
            PaymentRecord: {},
            purchaseOrderAvailableCredit: props.purchaseOrderAvailableCredit,
            purchaseOrderStatusOnHold: props.purchaseOrderStatusOnHold,
            UserNotes: props.initialData.UserNotes
        },
        // BBS DDD 2017-11-19 Data definitions and other things
        constants: {
            // Locations of server resources
            navigation: {
                MyAccountLink: '',
                checkoutUrl: props.checkoutUrl,
                ReceiptUrl: props.initialData.ReceiptUrl,
                addAddressEndpoint: props.addAddressEndpoint,
                deleteAddressEndpoint: props.deleteAddressEndpoint,
                cartSummaryEndpoint: props.cartSummaryEndpoint,
                placeOrderEndpoint: props.placeOrderEndpoint,
                orderConfirmationUrl: props.orderConfirmationUrl,
                updateItemQuantityEndpoint: props.updateQuantityEndpoint,
                deleteItemEndpoint: props.deleteItemEndpoint,
                refreshShippingOptionsEndpoint: props.refreshShippingOptionsEndpoint,
                termsAndConditionsUrl: props.termsAndConditionsUrl
            },
            ShippingAddressType: props.ShippingAddressType,
            BillingAddressType: props.BillingAddressType,
            countriesStatesMap: props.countriesStatesMap,
            countries: props.countries,
            acceptJsSettings: {
                apiLoginId: authorizeDotNetClientSettings.ApiLoginId,
                clientKey: authorizeDotNetClientSettings.ClientKey,
                environment: authorizeDotNetClientSettings.Environment,
                acceptJsPaymentId: authorizeDotNetClientSettings.AuthorizePaymentOptionId
            },
            allowBillingEqualsShipping: props.initialData.allowBillingEqualsShipping,
            purchaseOrderPaymentId: props.purchaseOrderPaymentId
        }
    }
}


export default mapTopLevelPropsToInitialStoreState